module.exports = __webpack_public_path__ + "img/about.d66d7e45.png";